<div class="ra-editor-wrapper notranslate" translate="no" [class.compact]="compact()" [class.inline]="inline()" [class.has-focus]="hasFocus()">
    <quill-editor 
        class="notranslate"
        [attr.translate]="'no'"
        [theme]="'snow'" 
        [format]="'json'"
        [modules]="modules" 
        [placeholder]="placeholder() || ('shared.editor.placeholder' | translate)"
        [(ngModel)]="valueEditor" 
        [disabled]="disabled() && !hasFocus()"
        [class.default-disabled]="disabled() && !hasFocus()"
        [class.compact-editor]="compact()"
        [maxLength]="limitCharacters()"
        (onEditorCreated)="onEditorCreated($event)"
        (onContentChanged)="onContentChange()"
        (onSelectionChanged)="onSelectionChanged($event)"
    />

    @if (showColorPicker()) {
        <div
            class="color-picker-popover"
            clickOutside
            [clickOutsideEnabled]="showColorPicker()"
            (clickOutside)="closeColorPicker()"
            [style.top.px]="colorPickerPosition().top"
            [style.left.px]="colorPickerPosition().left"
            [style.width.px]="colorPickerPosition().width"
            [style.max-height.px]="colorPickerPosition().maxHeight"
        >
            <div class="color-picker-header">
                <p class="ra-label-m bold">{{ colorPickerTitle() }}</p>

                <button
                    type="button"
                    class="color-picker-close"
                    (click)="closeColorPicker()"
                    [attr.aria-label]="'common.colorPicker.close' | translate">
                    <ra-icon icon="close" varColor="currentColor" [size]="16" />
                </button>
            </div>

            <div class="color-picker-content">
                <p class="ra-label-s content-secondary">{{ 'common.colorPicker.quickColors' | translate }}</p>

                <div class="quick-colors">
                    @for (color of quickColors; track color) {
                        <button
                            type="button"
                            class="quick-color"
                            [class.selected]="selectedColorHex().toUpperCase() === color"
                            [style.background-color]="color"
                            (click)="selectQuickColor(color)"
                            [attr.aria-label]="'Selecionar cor ' + color"
                        ></button>
                    }
                </div>

                <p class="ra-label-s content-secondary">{{ 'common.colorPicker.fullPalette' | translate }}</p>

                <div
                    class="color-area"
                    [style.background]="colorPaletteBackground()"
                    (mousedown)="onColorPalettePointer($event)"
                >
                    <span
                        class="color-area-cursor"
                        [style.left.%]="colorSaturation()"
                        [style.top.%]="100 - colorBrightness()"
                    ></span>
                </div>

                <div class="hue-slider-wrapper">
                    <input
                        type="range"
                        min="0"
                        max="359"
                        class="hue-slider"
                        [ngModel]="colorHue()"
                        (ngModelChange)="onHueChange($event)"
                        [attr.aria-label]="'common.colorPicker.selectHue' | translate"
                    />
                </div>

                <div class="hex-color-row">
                    <div
                        class="selected-color-preview"
                        [style.background-color]="selectedColorHex()"
                    ></div>

                    <label class="hex-color-input">
                        <span>#</span>
                        <input
                            type="text"
                            maxlength="6"
                            [ngModel]="selectedColorHex().replace('#', '')"
                            (ngModelChange)="onHexChange($event)"
                            [attr.aria-label]="'common.colorPicker.hex' | translate"
                        />
                    </label>
                </div>

                <button
                    type="button"
                    class="remove-color-button"
                    (click)="removeColor()"
                >
                    <ra-icon icon="close" varColor="currentColor" [size]="16" />
                    <span>{{ colorPickerMode() === 'background' ? 'Remover cor de fundo' : 'Remover cor do texto' }}</span>
                </button>
            </div>
        </div>
    }

    <!-- Autocomplete overlay -->
    @if (showAutocompleteList() && enableLinkAutocomplete()) {
        <div
            class="autocomplete-overlay"
            [style.top.px]="autocompletePosition()?.top ?? 0"
            [style.left.px]="autocompletePosition()?.left ?? 0"
        >
            <div class="autocomplete-list">
                @for (group of filteredLinksByCategory(); track group.categoryDescription) {
                    <div class="autocomplete-category">
                        <span class="autocomplete-category-label">{{ group.categoryDescription }}</span>
                        @for (item of group.items; track item.link.name + (item.link.value ?? '')) {
                            <button
                                type="button"
                                class="autocomplete-item"
                                [class.selected]="item.flatIndex === autocompleteIndex()"
                                (mousedown)="selectLink(item.link); $event.preventDefault()"
                            >
                                <ra-icon
                                    class="autocomplete-icon"
                                    [icon]="getLinkIcon(item.link)"
                                    [size]="18"
                                    varColor="contentTertiary"
                                />
                                <span class="autocomplete-value">{{ getLinkLabel(item.link) }}</span>
                            </button>
                        }
                    </div>
                }
                @empty {
                    <div class="autocomplete-empty">{{ 'shared.editor.noLinksFound' | translate }}</div>
                }
            </div>
        </div>
    }

    <!-- Dica ao usuário -->
    <p class="editor-hint ra-label-s content-secondary">{{ 'shared.editor.hintText' | translate }}</p>

    <!-- Limit characters -->
    @if (showLimitCharacters() && limitCharacters()) {
        <div class="container-limit-characters" [class.exceeded]="getTextLength() > limitCharacters()">
            <ra-icon 
                [icon]="'warning'" 
                [size]="16"
                [varColor]="'contentTertiary'"
            />

            <p class="ra-label-s content-secondary">{{ 'common.charactersCount' | translate:{ current: getTextLength(), limit: limitCharacters() } }}</p>
        </div>
    }
</div>
